import React from "react";
import "./FavoritesPanel.css";
import MovieCard from "./MovieCard";
import Icon from "./Icon";

export default function FavoritesPanel({ favorites, onSelect }) {
  return (
    <aside className="content-panel glass-panel favorites-panel">
      <div className="section-heading">
        <h2>
          <Icon name="heart" size={16} className="favorites-heading-icon" />
          Favoritos
        </h2>
        <span key={favorites.length} className="favorites-count-badge">
          {favorites.length} {favorites.length === 1 ? "guardada" : "guardadas"}
        </span>
      </div>

      {favorites.length ? (
        <div className="movie-grid favorites-grid">
          {favorites.map((movie) => (
            <MovieCard key={movie.id} movie={movie} onSelect={onSelect} />
          ))}
        </div>
      ) : (
        <div className="favorites-empty">
          <Icon name="heart" size={26} />
          <p>Sin favoritos todavía</p>
          <span>Marcá películas desde "Añadir a favoritos" para verlas acá.</span>
        </div>
      )}
    </aside>
  );
}
